/* Copyright Information: Created by BuyGroup */
import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Button,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
} from "reactstrap";

const validationSchema = Yup.object().shape({
  name: Yup.string().trim().required("First name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  role: Yup.string().oneOf(["ADMIN", "SUB_ADMIN"]).required("Role is required"),
  password: Yup.string().min(6, "Min 6 characters").required("Password is required"),
});

const CreateAdmin = (props) => {
  const closeHandler = () => props.onClose();

  return (
    <Modal isOpen={props.showModal} style={{ overlay: { opacity: 0.1 } }}>
      <ModalHeader toggle={closeHandler}>
        <h5 className="modal-title f-w-600">Create Admin</h5>
      </ModalHeader>
      <Formik initialValues={props.initialValues} onSubmit={props.onSubmit} validationSchema={validationSchema}>
        {({ values }) => (
          <Form>
            <ModalBody>
              <FormGroup>
                <Label className="col-form-label">Full Name</Label>
                <Field type="text" className="form-control" name="name" />
                <ErrorMessage name="first_name">{(msg) => <div className="input-feedback">{msg}</div>}</ErrorMessage>
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label">Email</Label>
                <Field type="email" className="form-control" name="email" />
                <ErrorMessage name="email">{(msg) => <div className="input-feedback">{msg}</div>}</ErrorMessage>
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label">Role</Label>
                <Field as={Input} type="select" className="form-control" name="role">
                  <option value="ADMIN">Admin</option>
                  <option value="SUB_ADMIN">Sub Admin</option>
                </Field>
                <ErrorMessage name="role">{(msg) => <div className="input-feedback">{msg}</div>}</ErrorMessage>
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label">Password</Label>
                <Field type="password" className="form-control" name="password" />
                <ErrorMessage name="password">{(msg) => <div className="input-feedback">{msg}</div>}</ErrorMessage>
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit" disabled={props.isDisableAdd}>
                {props.isDisableAdd ? "Please Wait" : "Create"}
              </Button>
              <Button type="button" color="light" onClick={closeHandler}>Cancel</Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CreateAdmin;
/* Copyright Information: Created by BuyGroup */


